import React from "react";

export default function CallForwardingSubscribe() {
  return <div>Anrufweiterleitung abonnieren</div>;
}
